module.exports = __webpack_public_path__ + "static/media/home-20-years-icon.420f952c.png";